import {
  GeometryTypeMap,
  GeometryType,
  Feature,
} from 'planning-portal-library/src/lib/core/domain/models/map/geoJson/geometryTypes';

export function createFeature<T extends GeometryType, P>(
  type: T,
  coordinates: GeometryTypeMap[T]['coordinates'],
  properties: P
): Feature<T, P> {
  const geometry: GeometryTypeMap[T] = {
    type,
    coordinates,
  } as GeometryTypeMap[T];

  return {
    type: 'Feature',
    geometry: geometry,
    properties,
  };
}
